module.exports = __webpack_public_path__ + "zhengpian.b797380f.png";